import createIcon from '../../createIcon';

/**
 * @component @name Radio
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMy4yNCA2LjY1QzIuNTEgNi45MyAyIDcuNjcgMiA4LjVWMjAuNUMyIDIxLjYgMi44OSAyMi41IDQgMjIuNUgyMEMyMS4xMSAyMi41IDIyIDIxLjYgMjIgMjAuNVY4LjVDMjIgNy4zOSAyMS4xMSA2LjUgMjAgNi41SDguM0wxNi41NiAzLjE2TDE1Ljg4IDEuNUwzLjI0IDYuNjVaTTcgMjAuNUM1LjM0IDIwLjUgNCAxOS4xNiA0IDE3LjVDNCAxNS44NCA1LjM0IDE0LjUgNyAxNC41QzguNjYgMTQuNSAxMCAxNS44NCAxMCAxNy41QzEwIDE5LjE2IDguNjYgMjAuNSA3IDIwLjVaTTIwIDEyLjVIMThWMTAuNUgxNlYxMi41SDRWOC41SDIwVjEyLjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Radio = createIcon('Radio', [
  [
    'path',
    {
      d: 'M3.24 6.65C2.51 6.93 2 7.67 2 8.5V20.5C2 21.6 2.89 22.5 4 22.5H20C21.11 22.5 22 21.6 22 20.5V8.5C22 7.39 21.11 6.5 20 6.5H8.3L16.56 3.16L15.88 1.5L3.24 6.65ZM7 20.5C5.34 20.5 4 19.16 4 17.5C4 15.84 5.34 14.5 7 14.5C8.66 14.5 10 15.84 10 17.5C10 19.16 8.66 20.5 7 20.5ZM20 12.5H18V10.5H16V12.5H4V8.5H20V12.5Z',
      key: '8edkek',
    },
  ],
]);

export default Radio;
